import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { useCalendarContext } from '../../context/calendarProvider.mjs';
import { Container, ButtonGroup, LabelFilterIcon, MonthDisplay, CalendarIcon, SearchIcon } from './styled.mjs';

var Header = function Header(_ref) {
  var userLocale = _ref.userLocale;
  var _useCalendarContext = useCalendarContext(),
    selectedDateValue = _useCalendarContext.selectedDateValue;
  var dateStr = React__default.useMemo(function () {
    var date = new Date(selectedDateValue);
    return new Intl.DateTimeFormat(userLocale, {
      year: "numeric",
      month: "short"
    }).format(date);
  }, [userLocale, selectedDateValue]);
  return jsxs(Container, {
    children: [jsx(ButtonGroup, {
      "$position": "left",
      children: jsx(LabelFilterIcon, {})
    }), jsx(MonthDisplay, {
      children: dateStr
    }), jsxs(ButtonGroup, {
      "$position": "right",
      children: [jsx(CalendarIcon, {}), jsx(SearchIcon, {})]
    })]
  });
};

export { Header };
